/**
 * POST /client/.../members/{subId}/dependents
 * DELETE /client/.../members/{subId}/dependents/{dependentId} (body required)
 */

export type MemberPortalDependentRelationship = 'SPOUSE' | 'CHILD' | 'PARTNER';

/** Values allowed when adding a dependent from the HR portal (subset of {@link MemberPortalDependentRelationship}). */
export type AddMemberDependentRelationship = 'SPOUSE' | 'CHILD';

/** Request body to add or update a dependent (POST and PUT). */
export interface MemberDependentRequestDto {
  firstName: string;
  lastName: string;
  /** Omit or null when not provided. */
  middleName?: string | null;
  dateOfBirth: string;
  relationship: MemberPortalDependentRelationship;
}

export type MemberDependentInactiveReason = 1 | 2 | 3;

export interface RemoveMemberDependentRequestDto {
  inactiveReason: MemberDependentInactiveReason;
  /** ISO date (yyyy-MM-dd): coverage end / when the reason took effect. */
  inactiveDate: string;
}

/** All relationship values the API may use; portal add flow only offers {@link MEMBER_PORTAL_ADD_DEPENDENT_RELATIONSHIP_OPTIONS}. */
export const MEMBER_PORTAL_DEPENDENT_RELATIONSHIP_OPTIONS: ReadonlyArray<{
  value: MemberPortalDependentRelationship;
  label: string;
}> = [
  { value: 'SPOUSE', label: 'Spouse' },
  { value: 'CHILD', label: 'Child' },
  { value: 'PARTNER', label: 'Partner' }
];

/** HR portal: add dependent — Spouse and Child only. */
export const MEMBER_PORTAL_ADD_DEPENDENT_RELATIONSHIP_OPTIONS: ReadonlyArray<{
  value: AddMemberDependentRelationship;
  label: string;
}> = [
  { value: 'SPOUSE', label: 'Spouse' },
  { value: 'CHILD', label: 'Child' }
];

export const MEMBER_DEPENDENT_INACTIVE_REASON_OPTIONS: ReadonlyArray<{
  value: MemberDependentInactiveReason;
  label: string;
}> = [
  { value: 1, label: 'No longer meets age criteria' },
  { value: 2, label: 'Relationship no longer valid' },
  { value: 3, label: 'Deceased' }
];
